import {appApi} from "./api.service";
import {Notification} from "../models/notification";
import { PushNotifications, PushNotification, PushNotificationActionPerformed, PushNotificationToken} from "@capacitor/push-notifications";
import {getCurrentNetworkStatus} from "@services/offlineSync.service";

const push = async () => {

	// Register with Apple / Google to receive push via APNS/FCM
	//PushNotifications.register();

	// On success, we should be able to receive notifications
	await PushNotifications.addListener('registration',
		(token: PushNotificationToken) => {
			addFcmToken(token.value);
		}
	);

	PushNotifications.requestPermissions().then(result => {
		if (result.receive === 'granted') {
			// Register with Apple / Google to receive push via APNS/FCM
			PushNotifications.register();
		} else {
			// error
		}
	});
}

const addFcmToken = async (token: string) => {
	return appApi.post('user/profile/fcm/token/add', { fcmToken: token });
};

const getNotifications = async (hideLoader: boolean = false) => {
    if(hideLoader) {
        return appApi.get('user/notifications', {
            headers: {
                'No-Loader': true
            }
        });
    } else {
        return appApi.get('user/notifications');
    }
};

const getNotAcceptedObligatoryNotifications = async (): Promise<Notification[]> => {
    const networkStatus = await getCurrentNetworkStatus();

    if (networkStatus) {
        const response = await appApi.get('worker/notifications/not-accepted-obligatory');

        return response.data;
    }

    return [];
};

const acceptObligatoryNotification = async (id: bigint) => {
    const response = await appApi.post(`worker/notifications/${id}/accept-obligatory`);

    return response.data;
}

const getUnreadNotifications = async () => {
    return await getNotifications(true).then(response => {
        let notifications: [] = response?.data ;

        return notifications.filter((notification: Notification) => {
            return notification.status === 'sent';
        });
    });
}

const hasUnreadNotifications = async () => {
    return await getUnreadNotifications().then(r => r.length > 0);
}

const markNotificationAsRead = async (notificationId: string|bigint) => {
    return appApi.post('user/notifications/'+notificationId+ '/mark-as-read', {}, {
        headers: {
            'No-Loader': true
        }
    });
};

export {
	push,
    addFcmToken,
    getNotifications,
    markNotificationAsRead,
    getUnreadNotifications,
    hasUnreadNotifications,
    getNotAcceptedObligatoryNotifications,
    acceptObligatoryNotification,
}
